import { render } from "./MessageAlert.vue?vue&type=template&id=3aa47817"
import script from "./MessageAlert.vue?vue&type=script&lang=js"
export * from "./MessageAlert.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whitebox-portal/whitebox-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__